module.exports = __webpack_public_path__ + "static/media/close-white.597dc2fa.svg";